// Page numbering system for the cookbook experience
export const PAGE_NUMBERS = {
  // Title Page / Dashboard (Home Screen)
  HOME_LEFT: 1,
  HOME_RIGHT: 2,
  
  // Recipe List Cover (Intro to collection)
  RECIPE_LIST_COVER_LEFT: 3,
  RECIPE_LIST_COVER_RIGHT: 4,

  // Table of Contents
  RECIPE_TOC_LEFT: 5,
  RECIPE_TOC_RIGHT: 6,
  
  // Recipe Pages (dynamically calculated)
  // Each recipe gets 2 pages (left + right), starting from page 7
  RECIPE_PAGES_START: 7,
  
  // Back Matter - using high numbers to ensure they are at the end
  // In a real dynamic system we might calculate these based on total recipes
  HELP_LEFT: 994,
  HELP_RIGHT: 995,
  ABOUT_LEFT: 996,
  ABOUT_RIGHT: 997,
  RECIPE_CAPTURE: 998,
  SETTINGS: 999,
} as const;

export const getRecipePageNumbers = (recipeIndex: number): { left: number; right: number } => {
  const startPage = PAGE_NUMBERS.RECIPE_PAGES_START + (recipeIndex * 2);
  return {
    left: startPage,
    right: startPage + 1,
  };
};

export const getPageNumberForRoute = (pathname: string, recipeIndex?: number): number => {
  if (pathname === '/home' || pathname === '/') {
    return PAGE_NUMBERS.HOME_LEFT;
  }
  
  if (pathname === '/recipes') {
    // This depends on view mode, but we default to the cover/intro
    return PAGE_NUMBERS.RECIPE_LIST_COVER_LEFT;
  }
  
  if (pathname === '/capture') {
    return PAGE_NUMBERS.RECIPE_CAPTURE;
  }
  
  if (pathname === '/settings') {
    return PAGE_NUMBERS.SETTINGS;
  }

  if (pathname === '/help') {
    return PAGE_NUMBERS.HELP_LEFT;
  }

  if (pathname === '/about') {
    return PAGE_NUMBERS.ABOUT_LEFT;
  }

  if (pathname.startsWith('/recipes/') && recipeIndex !== undefined) {
    return getRecipePageNumbers(recipeIndex).left;
  }

  return 1; // Default fallback
};
